module.exports = __webpack_public_path__ + "img/icon_plus_01.2317152f.png";